module.exports = __webpack_public_path__ + "img/V40.0030e957.jpg";